// extracted by mini-css-extract-plugin
export var borderRadius = "_ei-4";
export var large = "_ei-3";
export var logoContainer = "_ei-0";
export var nameLogo = "_ei-2";
export var small = "_ei-1";